import React, { useState, useContext } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ModalContext } from '..';
import AlertEnum from '../../Alert/enums/AlertEnum';
import { useSelector } from 'react-redux';
import {
  addImagesToReport,
  setActiveDraftReport,
  clearReportInfo,
} from '../../../../store/slices/reportSlice';
import { useAppDispatch } from '../../../../store/configureStore';
import { storeReportInfo } from '../../../../store/slices/reportSlice';
import { useNavigate } from 'react-router-dom';

/**
 * This is the second step of the report modal
 * It allows selected images to be added to an existing report
 *
 * @param {*} open - the current state of the modal, whether it is open or not
 * @param {*} setOpen - function to set the state of the modal
 * @returns {JSX.Element} - The AddToReport component
 */

export default function AddToReport({ open, setOpen, selectedImageIds }) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { closeModal, handleAlert } = useContext(ModalContext);
  const { draftReports = [] } = useSelector((state) => state.reportData);
  const [isButtonDisabled, setIsButtonDisabled] = useState(draftReports.length === 0);

  const [item, setItem] = useState(draftReports[0]?.report_id ?? '');

  const handleChangeDraftReport = ({ target }) => {
    setItem(target.value);
  };

  const addImages = async () => {
    setIsButtonDisabled(true);
    const reportInfo = await dispatch(setActiveDraftReport(item));
    const newReportInfo = await dispatch(addImagesToReport(reportInfo, selectedImageIds));
    await dispatch(storeReportInfo(newReportInfo));

    handleAlert(AlertEnum.REPORT_UPDATED);
    closeModal();

    await dispatch(clearReportInfo());
    navigate(`/report/${reportInfo.options.id}`);
  };

  return (
    <Accordion
      expanded={open === 'AddToReport'}
      onChange={() => setOpen('AddToReport')}
      sx={styles.container}
      square
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Add To An Existing Draft Report</Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.details}>
        <div>
          <Select sx={styles.select} value={item} onChange={handleChangeDraftReport}>
            {draftReports.map((report) => (
              <MenuItem key={report.report_id} value={report.report_id}>
                {report.report_name}
              </MenuItem>
            ))}
          </Select>
          <Button
            variant="contained"
            color="secondary"
            sx={styles.button}
            onClick={addImages}
            disabled={isButtonDisabled}
          >
            Add To Report
          </Button>
        </div>
      </AccordionDetails>
    </Accordion>
  );
}

const styles = {
  select: {
    width: 1,
  },
  container: {
    '::before': {
      display: 'none',
    },
    boxShadow: 'none',
    width: 1,
  },
  details: { display: 'flex', flexDirection: 'column' },
  button: { float: 'right', marginY: 2 },
};
